import { arrayOf, bool, func, number, shape } from 'prop-types';
import React from 'react';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';

import BulkToggleControls from '../../generic/BulkToggleControls';
import { campaignLineShape } from '../../prop-types';
import getEventTargetValue from '../../utils/get-event-target-value';
import CampaignLinesBulkEditor from '../CampaignLinesBulkEditor';
import CheckCreativeAssociationsButton from '../CheckCreativeAssociationsButton';
import DefaultTextAssets from '../TextBundlesModal';

function CampaignLinesTableHeader({
  editableCampaignLines,
  selectedCampaignLines,
  expandableLines,
  expandedLines,
  onToggleLines,
  onToggleAllExpansions,
  areCreativesVisible,
  onToggleCreativesVisibility,
  campaignId,
}) {
  return (
    <Row>
      <Col className="d-flex align-items-center">
        <BulkToggleControls
          onToggleAll={onToggleLines}
          entities={editableCampaignLines}
          activeEntities={selectedCampaignLines}
        />
        <BulkToggleControls
          onToggleAll={onToggleAllExpansions}
          entities={expandableLines}
          activeEntities={expandedLines}
          toggleAllOnLabel="Expand all"
          toggleAllOffLabel="Collapse all"
        />
        <FormGroup check>
          <Label check>
            <Input
              type="checkbox"
              checked={areCreativesVisible}
              onChange={({ target }) => {
                onToggleCreativesVisibility(getEventTargetValue(target));
              }}
            />{' '}
            Show creatives
          </Label>
        </FormGroup>
      </Col>
      <Col className="d-flex justify-content-end align-items-center">
        <div>
          <DefaultTextAssets />
        </div>
        <div className="ml-2">
          <CheckCreativeAssociationsButton campaignId={campaignId} />
        </div>
        <div className="mx-3" />
        <CampaignLinesBulkEditor />
      </Col>
    </Row>
  );
}

const expandableLineShape = { expanded: bool.isRequired };
CampaignLinesTableHeader.propTypes = {
  editableCampaignLines: arrayOf(campaignLineShape.isRequired).isRequired,
  selectedCampaignLines: arrayOf(campaignLineShape.isRequired).isRequired,
  expandableLines: arrayOf(shape(expandableLineShape).isRequired).isRequired,
  expandedLines: arrayOf(shape(expandableLineShape).isRequired).isRequired,
  onToggleLines: func.isRequired,
  onToggleAllExpansions: func.isRequired,
  areCreativesVisible: bool.isRequired,
  onToggleCreativesVisibility: func.isRequired,
  campaignId: number.isRequired,
};

export default CampaignLinesTableHeader;
